import { useState } from 'react';
import PlayButtonFlame from '../effects/PlayButtonFlame';
import PlayButtonExplosion from '../effects/PlayButtonExplosion';
import { PlayIcon, PauseIcon } from '../icons';

const BUTTON_R = 22;
const EXPLOSION_SCALE = BUTTON_R / 34;

export default function FirePlayToggle({ isPlaying, onClick, ariaLabel }) {
  const [trigger, setTrigger] = useState(0);

  const handleClick = (e) => {
    setTrigger((n) => n + 1);
    onClick?.(e);
  };

  return (
    <span className="play-toggle-wrap">
      <PlayButtonFlame active={isPlaying} buttonR={BUTTON_R} />
      <PlayButtonExplosion trigger={trigger} scale={EXPLOSION_SCALE} />
      <button
        key={trigger}
        className={`play-toggle ${trigger ? 'shake' : ''}`}
        onClick={handleClick}
        aria-label={ariaLabel || (isPlaying ? 'Pause' : 'Play')}
      >
        {isPlaying ? <PauseIcon /> : <PlayIcon />}
      </button>
    </span>
  );
}
